
.action-section {
    border-radius: 12px;
    padding: 0 4px;
    background: var(--base-bg-medium-hover);

    .action-candidate-buttons {
        display: flex;
        padding: 4px 10px;
        align-items: center;
        gap: 10px;
        justify-content: center;
        flex-flow: row nowrap;

    }

    .action-buttons {
        border-radius: 10px;
        background: var(--base-border-weak-default);
        display: flex;
        padding: 4px;
        align-items: center;
        gap: 4px;
    }

    .divider {
        width: 2px;
        height: 100%;
        background-color: var(--base-border-weak-default);
        &.hidden {
            visibility: hidden;
        }
    }

    button {
        white-space: nowrap;
        border: none;
        &:disabled {
            background-color: transparent;
        }
    }

    .event-count {
        color: var(--base-text-default);
        border: 2px solid var(--base-border-default);
        background: var(--interact-bg-weak-disabled);
    }
}